import { Routes } from '@angular/router';
import { PagesLayoutComponent } from './pages/common/components/layout/layout.component';
import { PrivateLayoutComponent } from './pages/common/components/private-layout/private-layout.component';
import { authenticationGuard } from '@core/guards/authentication-guard';
import { roleGuard } from '@core/guards/role-guard-guard';

export const routes: Routes = [
  {
    path: '',
    component: PagesLayoutComponent,
    children: [
      {
        path: '',
        title: 'Inicio',
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
        pathMatch: 'full',
      },
      {
        path: 'acceder',
        title: 'acceder',
        loadChildren: () => import('./pages/login/login.routes').then((m) => m.loginRoutes),
      },
      {
        path: 'certificaciones',
        title: 'Certificaciones',
        loadComponent: () =>
          import('./pages/home/certificaciones/certificaciones.component').then(
            (m) => m.CertificacionesComponent,
          ),
      },
    ],
  },
  {
    path: 'app',
    component: PrivateLayoutComponent,
    canActivate: [authenticationGuard],
    canActivateChild: [authenticationGuard, roleGuard],
    children: [
      {
        path: 'perfil-usuario',
        title: 'Perfil de Usuario',
        loadComponent: () =>
          import('./pages/app/perfil-usuario/perfil-usuario.component').then(
            (m) => m.PerfilUsuario,
          ),
      },
      {
        path: 'perfil-usuario/editar',
        title: 'Editar Campo',
        loadComponent: () =>
          import('./pages/app/perfil-usuario/editar-compo-perfil/editar-campo-perfil.component').then(
            (m) => m.EditarCampoPerfilComponent,
          ),
      },
      {
        path: 'perfil-usuario/editar-direccion',
        title: 'Editar Dirección',
        loadComponent: () =>
          import('./pages/app/perfil-usuario/editar-direccion/editar-direccion.component').then(
            (m) => m.EditarDireccionComponent,
          ),
      },
      {
        path: 'perfil-usuario/editar-contacto-alterno',
        title: 'Editar Contacto Alterno',
        loadComponent: () =>
          import('./pages/app/perfil-usuario/editar-contacto-alterno/editar-contacto-alterno').then(
            (m) => m.EditarContactoAlterno,
          ),
      },
      {
        path: 'perfil-usuario/editar-config-debito',
        title: 'Configuración de Débito',
        loadComponent: () =>
          import('./pages/app/perfil-usuario/editar-config-debito/editar-config-debito.component').then(
            (m) => m.EditarConfigDebitoComponent,
          ),
      },
      {
        path: 'metodo-pago',
        title: 'Métodos de Pago',
        loadComponent: () =>
          import('./pages/app/metodo-pago/pages/metodo-pago.page').then((m) => m.MetodoPagoPage),
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        loadComponent: () =>
          import('./pages/app/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'realizar-aporte',
        title: 'Realizar Aporte',
        loadComponent: () =>
          import('./pages/app/realizar-aporte/realizar-aporte.component').then(
            (m) => m.RealizarAporteComponent,
          ),
      },
      {
        path: 'retirar-aporte',
        title: 'Retirar Fondos',
        loadComponent: () =>
          import('./pages/app/retirar-aporte/retirar-aporte.component').then(
            (m) => m.RetirarAporteComponent,
          ),
      },
      {
        path: 'calcular-objetivo-ahorro',
        title: 'Calcular Objetivo de Ahorro',
        loadComponent: () =>
          import('./pages/app/calcular-objetivo-ahorro/calcular-objetivo-ahorro').then(
            (m) => m.CalcularObjetivoAhorroComponent,
          ),
      },
      {
        path: 'consultar-estado-cuenta',
        title: 'Consultar Estado de Cuenta',
        loadComponent: () =>
          import('./pages/app/consultar-estado-cuenta/consultar-estado-cuenta.component').then(
            (m) => m.ConsultarEstadoCuentaComponent,
          ),
      },
      {
        path: 'notificaciones',
        title: 'Notificaciones',
        loadComponent: () =>
          import('./pages/app/notificaciones/notificaciones.component').then(
            (m) => m.NotificacionesComponent,
          ),
      },
      {
        path: 'mis-objetivos-ahorro',
        title: 'Mis Objetivos de Ahorro',
        loadComponent: () =>
          import('./pages/app/mis-objetivos-ahorro/mis-objetivos-ahorro.component').then(
            (m) => m.MisObjetivosAhorroComponent,
          ),
      },
      {
        path: 'objetivo-ahorro/:id',
        title: 'Detalle de Objetivo',
        loadComponent: () =>
          import('./pages/app/detalle-objetivo-ahorro/detalle-objetivo-ahorro.component').then(
            (m) => m.DetalleObjetivoAhorroComponent,
          ),
      },
      {
        path: 'crear-objetivo',
        title: 'Crear Objetivo',
        loadComponent: () =>
          import('./pages/app/crear-objetivo/crear-objetivo.component').then(
            (m) => m.CrearObjetivoComponent,
          ),
      },
      {
        path: 'modificar-objetivo/:id',
        title: 'Modificar Objetivo',
        loadComponent: () =>
          import('./pages/app/modificar-objetivo/modificar-objetivo.component').then(
            (m) => m.ModificarObjetivoComponent,
          ),
      },
      {
        path: 'preguntas-frecuentes',
        title: 'Preguntas Frecuentes',
        loadComponent: () =>
          import('./pages/app/preguntas-frecuentes/preguntas-frecuentes-page.component').then(
            (m) => m.PreguntasFrecuentesPageComponent,
          ),
      },
      {
        path: 'cambiar-password',
        title: 'Cambiar Contraseña',
        loadComponent: () =>
          import('./pages/app/cambiar-password/cambiar-password.component').then(
            (m) => m.CambiarPasswordComponent,
          ),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('@pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
